export default [
    // {
    //     path: '/hourGroups',
    //     name: 'hourGroups',
    //     component: () => import ('./pages/index')
    // },
]